import styled from 'styled-components';
import media from '../../styles/media.style';

const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 0 auto 50px;
  position: relative;
  text-align: center;

  ${media.tabletL`
    font-size: 18px;
    letter-spacing: 0.7px;
    margin: 0 auto 85px;
  `};

  &::after {
    background-color: black;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

export default SectionLabel;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/SectionLabel.js